navigationActions = require '../actions/navigation'

module.exports =
  componentWillMount: ->
    navigationActions.lightMode()



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/mixins/light-mode.cjsx
 **/